import { faChartColumn, faChevronDown, faChevronRight, faChevronLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Collapse } from '@material-ui/core';
import * as React from 'react';
import { Dispatch, SetStateAction, useEffect } from 'react';
import VoxelIconButton from '../../../components/voxel/Buttons/VoxelIconButton';
import VoxelDrawerMenuItem from '../../../components/voxel/Drawers/VoxelDrawerMenuItem';
import VoxelTooltipShort from '../../../components/voxel/Tooltip/VoxelTooltipShort';
import { AnalysisListItem } from '../AnalysisList';
import VoxelVerticalDrawer from '../../../components/voxel/Drawers/VoxelVerticalDrawer';

export interface AnalysisDrawerProps {
  analysisList: AnalysisListItem[];
  openDrawer: boolean;
  setOpenDrawer: Dispatch<SetStateAction<boolean>>;
  selectedAnalysisId: string;
  setSelectedAnalysisId: Dispatch<SetStateAction<string>>;
  getAnalysisUrl: (analysisId: string) => string;
}

const AnalysisDrawer: React.FC<AnalysisDrawerProps> = ({
  analysisList,
  openDrawer,
  setOpenDrawer,
  selectedAnalysisId,
  setSelectedAnalysisId,
  getAnalysisUrl,
}) => {
  const [collapseIndexList, setCollapseIndexList] = React.useState<number[]>([]);

  const handleCollapse = (collapseIndex: number) => {
    if (!collapseIndexList.includes(collapseIndex)) {
      var newArray = collapseIndexList.concat(collapseIndex);
    } else {
      var newArray = collapseIndexList.filter((v) => v !== collapseIndex);
    }
    setCollapseIndexList(newArray);
  };

  useEffect(() => {
    const parentIndex = analysisList.findIndex((parent) =>
      parent.analysisList?.some((chart) => chart.downloadId === selectedAnalysisId)
    );
    if (parentIndex > -1 && !collapseIndexList.includes(parentIndex)) {
      handleCollapse(parentIndex);
    }
  }, [selectedAnalysisId]);

  return (
    <VoxelVerticalDrawer
      open={openDrawer}
      closedWidthClass='w-12'
      openWidthClass='w-80'
      shadowClass='shadow-none'
      bgColorClass='bg-white'
      zIndexClass='z-20'
    >
      {!openDrawer ? (
        <div className="pt-3 px-2 flex justify-center">
          <VoxelTooltipShort message={'Insights'}>
            <VoxelIconButton
              color="white"
              onClick={() => setOpenDrawer(true)}
              size="md"
              icon={<FontAwesomeIcon icon={faChartColumn} size="xl" />}
            />
          </VoxelTooltipShort>
        </div>
      ) : (
        <div className={`h-full flex flex-col flex-nowrap `}>
          <div className="flex flex-row items-center px-2 pt-3 pb-2">
            <div className="flex-grow" />
            <VoxelIconButton
              color="white"
              onClick={() => setOpenDrawer(false)}
              size="md"
              icon={<FontAwesomeIcon icon={faChevronLeft} />}
            />
          </div>
          <div className={`flex flex-col max-h-[calc(100vh-4*32px)] overflow-y-auto`}>
            {analysisList.map((a, index) => {
              const parent = !a.chart;
              const open = parent && collapseIndexList.includes(index);
              return (
                <React.Fragment key={index}>
                  <VoxelDrawerMenuItem
                    variant="emphasis"
                    href=""
                    disabled={a.disabled || a.analysisList?.every((ai) => ai.disabled)}
                    onClick={(event) => {
                      event.preventDefault();
                      handleCollapse(index);
                    }}
                  >
                    <div className="flex flex-row items-center">
                      <span>{a.menuName}</span>
                      <div className="flex-grow" />
                      <FontAwesomeIcon size="sm" icon={open ? faChevronDown : faChevronRight} />
                    </div>
                  </VoxelDrawerMenuItem>
                  {!a.chart && (
                    <div className="pb-1">
                      <Collapse in={open} timeout="auto" unmountOnExit>
                        <div className="flex flex-col">
                          {a.analysisList.map((subA, subIndex) => (
                            <VoxelDrawerMenuItem
                              key={subIndex}
                              indented
                              href={getAnalysisUrl(subA.downloadId)}
                              onClick={(event) => {
                                event?.preventDefault();
                                if (subA.disabled) return;
                                setSelectedAnalysisId(subA.downloadId);
                              }}
                              selected={selectedAnalysisId === subA.downloadId}
                              disabled={subA.disabled}
                            >
                              {subA.menuName}
                            </VoxelDrawerMenuItem>
                          ))}
                        </div>
                      </Collapse>
                    </div>
                  )}
                </React.Fragment>
              );
            })}
          </div>
        </div>
      )}
    </VoxelVerticalDrawer>
  );
};

export default AnalysisDrawer;
